import { supabase } from '@/lib/supabase'

// The main app. Links in notifications point there: the leave history lives in
// the main app, and the same in-app notification shows in both apps.
const MAIN_APP_URL = 'https://portal.bohsa.com'

const longDate = (value) =>
  new Date(value).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })

/**
 * Tell the requester their leave request went in -- the same notification the
 * main app sends from RequestLeavePage for a self-submitted pending request.
 *
 * The approvers are emailed by the database (app_submit_leave_request_v3), so
 * this only covers the requester. Best effort: a failed notification must not
 * look like a failed request.
 */
export async function notifyLeaveSubmitted(request, requester) {
  if (!request?.id || !requester?.id) return

  const employeeName = [requester.first_name, requester.last_name].filter(Boolean).join(' ')

  try {
    await supabase.functions.invoke('process-notification', {
      body: {
        type: 'leave',
        leave_type: 'submitted',
        user_ids: [requester.id],
        title: 'Leave Request Submitted',
        message: 'Your leave request has been submitted and is pending approval',
        link_url: '/hr/history',
        entity_type: 'leave_request',
        entity_id: request.id,
        actor_id: requester.id,
        template_data: {
          employee_name: employeeName,
          leave_type: request.leave_type,
          start_date: longDate(request.start_date),
          end_date: longDate(request.end_date),
          total_days: request.calculated_days ?? 0,
          submission_date: new Date().toLocaleDateString('en-GB', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
          }),
          creator_name: employeeName,
          admin_notes: request.user_note || '',
          app_url: MAIN_APP_URL,
          short_link: `${MAIN_APP_URL}/hr/history`,
        },
      },
    })
  } catch (err) {
    console.error('[Leave] Failed to send submitted notification:', err)
  }
}
